/**
 * @generated SignedSource<<29d5e98bc84c67324cdf52dae880a655>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersistenceState = "PENDING" | "SAVED" | "UPLOADING" | "%future added value";
export type useVaultUploader_copyDraftVaultItem_Mutation$variables = {
  draftVaultItemId: string;
  vaultId?: string | null;
};
export type useVaultUploader_copyDraftVaultItem_Mutation$data = {
  readonly copyDraftVaultItem: {
    readonly draftUploadGroup: {
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly content: {
              readonly id?: string;
              readonly mimeType?: string;
              readonly name?: string;
              readonly persistenceState?: PersistenceState;
            } | null;
            readonly id: string;
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"VaultUploaderFileCard_draftItem">;
          } | null;
        }>;
      };
    };
    readonly draftVaultItemCreated: {
      readonly content: {
        readonly id?: string;
        readonly mimeType?: string;
        readonly name?: string;
        readonly persistenceState?: PersistenceState;
      } | null;
      readonly id: string;
    };
  } | null;
};
export type useVaultUploader_copyDraftVaultItem_Mutation = {
  response: useVaultUploader_copyDraftVaultItem_Mutation$data;
  variables: useVaultUploader_copyDraftVaultItem_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftVaultItemId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "draftVaultItemId",
        "variableName": "draftVaultItemId"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "returnUploadingFile",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "persistenceState",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": (v4/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": "content(returnUploadingFile:true)"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  (v2/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": (v4/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v6/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": "content(returnUploadingFile:true)"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = [
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  },
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVaultUploader_copyDraftVaultItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsCopyDraftVaultItemMutationPayload",
        "kind": "LinkedField",
        "name": "copyDraftVaultItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftUploadGroup",
            "kind": "LinkedField",
            "name": "draftUploadGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultDraftItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VaultDraftItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultDraftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "VaultUploaderFileCard_draftItem"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftItem",
            "kind": "LinkedField",
            "name": "draftVaultItemCreated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVaultUploader_copyDraftVaultItem_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VaultsCopyDraftVaultItemMutationPayload",
        "kind": "LinkedField",
        "name": "copyDraftVaultItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftUploadGroup",
            "kind": "LinkedField",
            "name": "draftUploadGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultDraftItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VaultDraftItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultDraftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cover",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Vault",
                            "kind": "LinkedField",
                            "name": "vault",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v13/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Thumbnail",
                                "kind": "LinkedField",
                                "name": "thumbnail",
                                "plural": false,
                                "selections": (v14/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Vault",
                                    "kind": "LinkedField",
                                    "name": "vault",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "roles",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthorizationResult",
                                    "kind": "LinkedField",
                                    "name": "canUpdateSecurity",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "preventDownload",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasWatermark",
                                    "storageKey": null
                                  }
                                ],
                                "type": "HasNodeSecurityInterface",
                                "abstractKey": "__isHasNodeSecurityInterface"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "folderItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "FolderItem",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "vaultItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "VaultItem",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "draftVaultItemContent",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "VaultDraftItem",
                                "abstractKey": null
                              }
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultDraftItem",
            "kind": "LinkedField",
            "name": "draftVaultItemCreated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca0655fc7f43588814efe3680236597b",
    "id": null,
    "metadata": {},
    "name": "useVaultUploader_copyDraftVaultItem_Mutation",
    "operationKind": "mutation",
    "text": "mutation useVaultUploader_copyDraftVaultItem_Mutation(\n  $draftVaultItemId: ID!\n  $vaultId: ID\n) {\n  copyDraftVaultItem(input: {draftVaultItemId: $draftVaultItemId, vaultId: $vaultId}) {\n    draftUploadGroup {\n      id\n      items {\n        edges {\n          node {\n            id\n            name\n            content(returnUploadingFile: true) {\n              __typename\n              ... on File {\n                id\n                name\n                mimeType\n                persistenceState\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on PendingFile {\n                id\n              }\n            }\n            ...VaultUploaderFileCard_draftItem\n          }\n        }\n      }\n    }\n    draftVaultItemCreated {\n      id\n      content(returnUploadingFile: true) {\n        __typename\n        ... on File {\n          id\n          name\n          mimeType\n          persistenceState\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SelectedVault_vault on Vault {\n  id\n  ...VaultAvatar_vault\n  name\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultAvatar_vault on Vault {\n  id\n  name\n  members {\n    id\n    ...UserAvatar_member\n  }\n  thumbnail {\n    url\n  }\n}\n\nfragment VaultUploaderFileCard_draftItem on VaultDraftItem {\n  id\n  ...useNodeSecurity_node\n  cover\n  vault {\n    name\n    ...SelectedVault_vault\n    member {\n      id\n      name\n      email\n      vault {\n        id\n      }\n      ...UserHandle_member\n    }\n    id\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a1d24646917bead5b5215e5447ca973";

export default node;
